<ng-content select="vds-header-menu"></ng-content>
<ng-content select="[vds-header-logo]"></ng-content>
<div class="vds-header-actions">
    <ng-content select="[vds-header-actions]"></ng-content>
</div>
